import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { FieldError } from "react-hook-form";

import FormInputLabel from "./FormInputLabel";
import { startOfDay } from "../utils/dateFormatters";

export type FormDateInputProps = {
    label: string
    value: Date | null
    name: string
    onChange: (value: Date | null) => void
    error?: FieldError
    minDate?: Date
    maxDate?: Date
    required?: boolean
    hideHelpText?: boolean
}

const FormDateInput = ({
    label,
    value,
    name,
    onChange,
    error,
    minDate,
    maxDate,
    required,
}: FormDateInputProps) => {
    return (
        <div className="w-full space-y-2">
            <FormInputLabel required={required}>{label}</FormInputLabel>
            <DesktopDatePicker
                format="dd/MM/yyyy"
                value={value}
                name={name}
                onOpen={() => {
                    if (!value && minDate) {
                        onChange(startOfDay(minDate));
                    }
                }}
                onChange={onChange}
                minDate={minDate ? startOfDay(minDate) : undefined}
                maxDate={maxDate}
                slotProps={{
                    textField: {
                        required,
                        fullWidth: true,
                        variant: "outlined",
                        name,
                        error: !!error,
                        helperText: error?.message as string | undefined,
                    },
                }}
            />
        </div>
    );
};

export default FormDateInput;